import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconArrowUpGraph: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
        xmlns: 'http://www.w3.org/2000/svg',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M0.293109 19.0752C0.683753 19.4656 1.31692 19.4654 1.70732 19.0747L8.64 12.1378L11.0453 14.5446C11.8265 15.3263 13.0936 15.3262 13.8747 14.5444L21 7.41268V9.7886C21 10.3409 21.4477 10.7886 22 10.7886C22.5523 10.7886 23 10.3409 23 9.7886V5.5C23 4.67157 22.3285 4 21.5 4H17.2114C16.6591 4 16.2114 4.44772 16.2114 5C16.2114 5.55229 16.6591 6 17.2114 6H19.5843L12.4599 13.1308L10.0546 10.7241C9.2735 9.94243 8.0065 9.94243 7.22535 10.7241L0.292677 17.661C-0.0977278 18.0516 -0.0975343 18.6848 0.293109 19.0752Z',
    })
  )
}
